import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SelectSearchModule } from '../select-search/select-search.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CountryCodeComponent } from './country-code.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [CountryCodeComponent],
  imports: [IntrackFeatureModule, SelectSearchModule, TranslateModule, NgxMatSelectSearchModule, SvgIconModule],
  exports: [CountryCodeComponent],
})
export class CountryCodeModule {}
